export const colors = {
    black: '#2D2D2D',
    blue: '#438DD5',
    green: '#34A548',
    red: '#E90505',
    white: '#FFF',
}

export const shadows = {
    button: '0px 8px 20px rgba(0, 0, 0, 0.25)',
    buttonHover: '0px 1px 2px 0px rgba(0,0,0,0.7)',
}